//React
import React, { Component } from "react";
import PropTypes from "prop-types";
//CSS
import "./inputs.scss";

function Radio({ name, options, required, disabled, label, style, selected, error, info, onInput }) {
	const wrapperClasses = [
		"input-wrapper radio-group",
		error ? "error" : "valid",
		required ? "required" : "not-required",
		disabled ? "disabled" : "enabled",
		style,
	];
	return (
		<div className={wrapperClasses.join(" ")}>
			{label ?? false ? <label>{label}</label> : ""}
			<div className="options-wrapper">
				{options.map((opt, i) => (
					<label
						key={i}
						className="form-control"
					>
						<input
							type="radio"
							name={name}
							value={opt.value
								.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
								.join("-")
								.toLowerCase()}
							required={required}
							checked={(selected ? selected.value : "") == opt.value}
							disabled={disabled}
							onChange={() => onInput(opt)}
						/>
						<span>{opt.label}</span>
					</label>
				))}
			</div>
			{info ?? false ? <div className="input-info">{info}</div> : ""}
		</div>
	);
}

Radio.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	required: PropTypes.bool.isRequired,
	disabled: PropTypes.bool.isRequired,
	style: PropTypes.oneOf(["row", "list"]).isRequired,
	label: PropTypes.string,
	info: PropTypes.string,
	error: PropTypes.bool,
	selected: PropTypes.any,
	onInput: PropTypes.func,
};

export default Radio;
